/**
 * Theme Engine — named palette moods.
 *
 * A theme is a pool of seed colors plus harmony and dark-mode biases. The
 * variation engine draws one seed + one harmony from the chosen theme; the
 * Design Engine's color harmony engine does the rest. Themes are what let
 * a category say "restaurants look warm, corporate looks cool" without
 * hard-coding palettes.
 */

export const PALETTE_THEMES = {
  vibrant: {
    id: 'vibrant', name: 'Vibrant',
    seeds: ['#ef4444', '#f97316', '#eab308', '#22c55e', '#3b82f6', '#a855f7'],
    harmonies: ['complementary', 'triadic'],
    darkChance: 0.2,
  },
  pastel: {
    id: 'pastel', name: 'Pastel',
    seeds: ['#f9a8d4', '#a5b4fc', '#99f6e4', '#fde68a', '#c4b5fd'],
    harmonies: ['analogous', 'monochrome'],
    darkChance: 0,
  },
  luxury: {
    id: 'luxury', name: 'Luxury',
    seeds: ['#b45309', '#7c2d12', '#1e1b4b', '#701a75', '#0f172a'],
    harmonies: ['monochrome', 'analogous'],
    darkChance: 0.6,
  },
  earthy: {
    id: 'earthy', name: 'Earthy',
    seeds: ['#84cc16', '#65a30d', '#a16207', '#92400e', '#166534'],
    harmonies: ['analogous', 'monochrome'],
    darkChance: 0.15,
  },
  corporate: {
    id: 'corporate', name: 'Corporate',
    seeds: ['#1d4ed8', '#0e7490', '#334155', '#4338ca', '#0f766e'],
    harmonies: ['monochrome', 'complementary'],
    darkChance: 0.25,
  },
  fresh: {
    id: 'fresh', name: 'Fresh',
    seeds: ['#10b981', '#06b6d4', '#84cc16', '#14b8a6', '#0ea5e9'],
    harmonies: ['analogous', 'triadic'],
    darkChance: 0.1,
  },
  warm: {
    id: 'warm', name: 'Warm',
    seeds: ['#f59e0b', '#ea580c', '#dc2626', '#d97706', '#db2777'],
    harmonies: ['analogous', 'complementary'],
    darkChance: 0.15,
  },
  midnight: {
    id: 'midnight', name: 'Midnight',
    seeds: ['#6366f1', '#8b5cf6', '#0ea5e9', '#ec4899', '#22d3ee'],
    harmonies: ['triadic', 'complementary'],
    darkChance: 0.85,
  },
};

export const listPaletteThemes = () =>
  Object.values(PALETTE_THEMES).map(({ id, name }) => ({ id, name }));

export const getPaletteTheme = (id) => {
  const theme = PALETTE_THEMES[id];
  if (!theme) throw new Error(`Unknown palette theme "${id}"`);
  return theme;
};
